<template>
    <div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            timer: ''
        }
    },
    created() {
        this.reloadPage()
    },

    methods: {
        reloadPage() {
            let filial = JSON.parse(localStorage.filial);
      
            if (filial.fornecExt == 'S') {
                return false
            }

            const host = window.location.pathname;
            this.timer = setTimeout(() => {
                if (host == "/" || host == "/osPreventiva") {
                    this.$store.dispatch("os/fetchFromApi", {});
                } else if (host == '/osExterna') {
                    this.$store.dispatch('os/fetchFromApiExterna')
                } else if(host == '/osReabertas') {
                    this.$store.dispatch('os/fetchFromApiReabertas')
                } else if (host == '/osEmpilhadeira') {
                    this.$store.dispatch('os/fetchFromApiArmazem', {})
                }
                this.reloadPage();
            }, 1000 * 60 * 5);
        }
    },
    
    beforeDestroy() {
        clearTimeout(this.timer)
    }
} 
</script>